<template>
  <div class="p-6 max-w-3xl mx-auto">
    <!-- Main Heading -->
    <h1 class="text-3xl font-bold text-center mb-4" style="color: #08b6aa;">SOS Page</h1>

    <!-- Intro Text -->
    <p class="text-lg text-center mb-6 text-gray-700">
      Below is a list of resources to help you find urgent support. If you need help, don’t hesitate to ask.
      <strong>Your safety comes first.</strong>
    </p>

    <!-- 🚨 Emergency Help Options -->
    <section class="mb-6">
      <h2 class="text-xl font-semibold mb-2 section-heading">🚨 Emergency Help Options</h2>
      <ul class="sos-list">
        <li>
          <a href="tel:911" class="sos-link">Call 911</a> – For immediate emergencies.
        </li>
        <li>
          <a href="https://988lifeline.org" target="_blank" class="sos-link">
            Call 988 Suicide & Crisis Lifeline
          </a> – For urgent mental health support.
        </li>
      </ul>
    </section>

    <!-- 💬 Text or Chat for Help -->
    <section class="mb-6">
      <h2 class="text-xl font-semibold mb-2 section-heading">💬 Text or Chat for Help</h2>
      <ul class="sos-list">
        <li>
          <a href="https://www.crisistextline.org/" target="_blank" class="sos-link">
            Text "HELLO" to 741741
          </a> – Crisis Text Line for urgent support via text.
        </li>
      </ul>
    </section>

    <!-- 👥 Personal Support -->
    <section class="mb-6">
      <h2 class="text-xl font-semibold mb-2 section-heading">👥 Personal Support</h2>
      <ul class="sos-list">
        <li>
          <a href="#" class="sos-link">Contact My Therapist</a> – Quick access to your therapist’s contact information.
        </li>
        <li>
          <a href="#" class="sos-link">Contact My Emergency Contact</a> – Call or text your designated support person.
        </li>
      </ul>
    </section>

    <!-- 📚 Other Support Resources -->
    <section class="mb-6">
      <h2 class="text-xl font-semibold mb-2 section-heading">📚 Other Support Resources</h2>
      <ul class="sos-list">
        <li>
          <a href="#" class="sos-link">Find Local Mental Health Services</a> – Search for nearby mental health facilities or crisis centers.
        </li>
        <li>
          <a href="#" class="sos-link">View My Safety Plan</a> – Review the personal safety plan set up with your therapist.
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SOSPage',
};
</script>

<style scoped>
/* Force list styles off */
.sos-list {
  list-style-type: none;
  padding-left: 0;
  margin-left: 0;
}

/* Link Styling */
.sos-link {
  color: #293840; /* Charcoal Blue */
  font-weight: 600;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.sos-link:hover {
  color: #ff6d44; /* Bright Orange */
  cursor: pointer;
}

/* Section headings (Aqua Blue) */
.section-heading {
  color: #08b6aa;
}
</style>
